export enum TimeFilterValueEnum {
    All = 0,
    OnlineNow = 150000,
    LessThan30Mins = 1800000,
    LessThan1Hr = 3600000,
    LessThan8Hrs = 28800000,
    LessThan24Hrs = 86400000,
    LessThan72Hrs = 259200000,
    LessThan120Hrs = 432000000,
    LessThan168Hrs = 604800000,
    MoreThan168Hrs = 604800001,
    Never = -1
}
